import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BitwisePipe } from "./bitwise.pipe";

@NgModule({
	declarations: [BitwisePipe],
	imports: [CommonModule],
	exports: [BitwisePipe]
})
export class PipesModule { }
